module.exports = __webpack_public_path__ + "img/m-footer-logo.a562271a.png";